// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ul.Login_no-bullets__ellkL {
    list-style-type: none;
    padding: 0;
    margin-left: 01em;
}

ul.Login_red__Q8QwQ {
    color:red;
}

span.Login_error__6iUM9 {
    color:red;
    margin-bottom: 1em;
}

div.Login_fullscreen__bd9zl {
    background-color: white;
    width: 100%;
    height: 100%;
    opacity: 1 !important;
    
}

.Login_white__UT2yn {
    background-color: white;
    opacity: 1 !important;
}

.Login_gray__fdRkc {
    background-color: gray;
    opacity: 1 !important;
}

h7 {
    font-size: medium;
}

.Login_app-name__zkHHQ {
    color:rgb(4, 108, 245);
}`, "",{"version":3,"sources":["webpack://./src/components/Login.module.css"],"names":[],"mappings":"AAAA;IACI,qBAAqB;IACrB,UAAU;IACV,iBAAiB;AACrB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,SAAS;IACT,kBAAkB;AACtB;;AAEA;IACI,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,qBAAqB;;AAEzB;;AAEA;IACI,uBAAuB;IACvB,qBAAqB;AACzB;;AAEA;IACI,sBAAsB;IACtB,qBAAqB;AACzB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,sBAAsB;AAC1B","sourcesContent":["ul.no-bullets {\n    list-style-type: none;\n    padding: 0;\n    margin-left: 01em;\n}\n\nul.red {\n    color:red;\n}\n\nspan.error {\n    color:red;\n    margin-bottom: 1em;\n}\n\ndiv.fullscreen {\n    background-color: white;\n    width: 100%;\n    height: 100%;\n    opacity: 1 !important;\n    \n}\n\n.white {\n    background-color: white;\n    opacity: 1 !important;\n}\n\n.gray {\n    background-color: gray;\n    opacity: 1 !important;\n}\n\nh7 {\n    font-size: medium;\n}\n\n.app-name {\n    color:rgb(4, 108, 245);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"no-bullets": `Login_no-bullets__ellkL`,
	"red": `Login_red__Q8QwQ`,
	"error": `Login_error__6iUM9`,
	"fullscreen": `Login_fullscreen__bd9zl`,
	"white": `Login_white__UT2yn`,
	"gray": `Login_gray__fdRkc`,
	"app-name": `Login_app-name__zkHHQ`
};
export default ___CSS_LOADER_EXPORT___;
